import AsyncButton from "@/components/AsyncButton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ContractorsPlannedHoursWizardResultsPanel } from "@/modules/contractorsPlannedHoursWizard/components/ContractorsPlannedHoursWizardResultsPanel";
import {
  ContractorsPlannedHoursWizardTabId,
  useContractorsPlannedHoursWizardCalculate,
} from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardCalculate";
import { Calculator } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ContractorsPlannedHoursWizardListSection } from "./ContractorsPlannedHoursWizardListSection";

const TAB_CONTENT_CLASS =
  "m-0 flex min-h-0 flex-1 flex-col data-[state=inactive]:hidden";

export function ContractorsPlannedHoursWizardTabs() {
  const { t } = useTranslation();
  const {
    activeTab,
    setActiveTab,
    calculationResults,
    calculateMutation,
    handleCalculate,
    calculateDisabled,
  } = useContractorsPlannedHoursWizardCalculate();

  return (
    <Tabs
      value={activeTab}
      onValueChange={(v) =>
        setActiveTab(v as ContractorsPlannedHoursWizardTabId)
      }
      className="flex min-h-0 flex-1 flex-col gap-0.5"
    >
      <div className="flex grow-0 items-center justify-between gap-2">
        <AsyncButton
          variant="outline"
          size="sm"
          className="shrink-0"
          label={t("contractorsPlannedHoursWizard.actions.calculate")}
          loadingLabel={t("contractorsPlannedHoursWizard.actions.calculating")}
          loading={calculateMutation.isPending}
          disabled={calculateDisabled}
          onClick={handleCalculate}
          icon={<Calculator className="mr-2 h-4 w-4" />}
        />
        <TabsList>
          <TabsTrigger value="selecting">
            {t("contractorsPlannedHoursWizard.tabs.selecting")}
          </TabsTrigger>
          <TabsTrigger value="results">
            {t("contractorsPlannedHoursWizard.tabs.results")}
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="selecting" className={TAB_CONTENT_CLASS}>
        <ContractorsPlannedHoursWizardListSection />
      </TabsContent>

      <TabsContent value="results" className={TAB_CONTENT_CLASS}>
        <ContractorsPlannedHoursWizardResultsPanel
          results={calculationResults}
        />
      </TabsContent>
    </Tabs>
  );
}
